const aboutUsArray = [
  {
    name: "Kellen Linse",
    image: "./img/kellen.png",
    about: "Software developer, interested in all things tech. With a primary focus in Web Development, Embedded Systems, IoT, and LED related projects- including designing and building custom WiFi and Bluetooth enabled microcontrollers.",
    githubLink: "https://www.github.com/Kellen-Linse",
    linkedinLink: "https://www.linkedin.com/in/kellen-linse/"
  },
  {
    name: "Spencer Tower",
    image: "./img/spencer.png",
    about: "Software developer with a background in customer service, brewery production, and administration. Passionate about creatively innovating novel solutions through web development.",
    githubLink: "https://www.github.com/SpencerTower",
    linkedinLink: "https://www.linkedin.com/in/spencertower"
  },
  {
    name: "Andrew Enyeart",
    image: "./img/andrew.png",
    about: "Software developer and former bartender with a background in linguistics. Passion for customer-oriented solutions, elegant code, getting the details right, efficient debugging, and sharing knowledge with fellow humans. Clear and engaging communicator across technical and non-technical contexts.",
    githubLink: "https://www.github.com/aenyeart",
    linkedinLink: "https://www.linkedin.com/in/andrewenyeart"
  },
  {
    name: "Daniel Jackson",
    image: "./img/daniel.png",
    about: "Software developer and Veteran of the United States Marine Corps with background in data analysis, project management, and linguistics. Highly team oriented and result driven, and passionate about using code to maximize efficiency while developing creative, customer-focused solutions.",
    githubLink: "https://www.github.com/daniel-jacks",
    linkedinLink: "https://www.linkedin.com/in/daniel-jacob-jackson"
  }
]
export default aboutUsArray;